export default __webpack_public_path__ + "static/virtual_2-b0577a01b07ac01919d16f5f002ea8ab.png";